export const BUSINESS_CATALOG_NAMESPACE_PREFIX = 'business_catalog_';

export const PER_PAGE = 24;

export const COLUMNS = 3;

export const MOBILE_COLUMNS = 2;

export const CONTENT_HEIGHT = 122;

export const CARD_OFFSET = 8;

export const DOMAIN_HEIGHT = 18;
